import { Badge, Center, Group, Indicator, Text, Tooltip } from '@mantine/core'
import { IconNotebook } from '@tabler/icons-react';
import React from 'react'
import moment from 'moment/moment';

const ReviewStatusIndicator = ({reviewStatusId, reviewStatusName, reviewStatusDate, reviewNotes}) => {
  let statusColor = 'gray';

  switch(reviewStatusId) {
    case 1:
      statusColor = 'yellow';
      break;
    case 2:
      statusColor = 'green';
      break;
    case 3:
      statusColor = 'red';
      break;
    default:
      statusColor = 'gray';
      break;
  }

  return (
    <Center>
      <div style={{ textAlign: 'center' }}>
        <Tooltip withArrow label={reviewNotes} disabled={reviewStatusId !== 3} maw={250} p='md'>
          <Badge color={statusColor} size='md' variant='filled' miw={125}>
            {reviewStatusName}
          </Badge>
        </Tooltip>
        <Text size='sm' mt='xs'>
          {moment(reviewStatusDate).format('YYYY-MM-DD')}
        </Text>
      </div>
    </Center>
  )
}

export default ReviewStatusIndicator